/**
 * @fileoverview Input/output schemas for world-organization-details-ideation-v3.
 *
 * This agent generates creative directions for developing an organization's details.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';

export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.storyContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.loreContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.activeWorldOrganization.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.characters.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.initialChapterContent.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.userMessage.schema.shape,
});

export type Input = z.infer<typeof InputSchema>;

export const WorldOrganizationDetailsIdeaSchema = z.object({
  title: z.string().describe('A short, evocative title for this creative direction.'),
  summary: z.string().describe("A detailed summary of the organization's leadership, membership, goals, ideology, and narrative implications."),
});

export type WorldOrganizationDetailsIdea = z.infer<typeof WorldOrganizationDetailsIdeaSchema>;

export const OutputSchema = z.object({
  ideas: z.array(WorldOrganizationDetailsIdeaSchema).length(3).describe('An array of exactly three distinct organization detail concepts.'),
});

export type Output = z.infer<typeof OutputSchema>;
